import { OrderMessageCategory, OrderMessageEntry, Topping } from '@lib/types';

export function calculateItemTotalPrice(category: OrderMessageCategory) {
  let total = 0;

  category.items.map((item: OrderMessageEntry) => {
    let totalExtraPriceForItem = 0;
    item.item.topping.map((t: Topping) => {
      totalExtraPriceForItem =
        totalExtraPriceForItem +
        t.extraItems.reduce((accumulator, object) => {
          return accumulator + object.price;
        }, 0);
    });
    total += (item.price + totalExtraPriceForItem) * item.quantity;
  });

  return total;
}
